import { render, staticRenderFns } from "./ShareFilesModal.vue?vue&type=template&id=47a94ecc&scoped=true"
import script from "./ShareFilesModal.vue?vue&type=script&lang=js"
export * from "./ShareFilesModal.vue?vue&type=script&lang=js"
import style0 from "./ShareFilesModal.vue?vue&type=style&index=0&id=47a94ecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a94ecc",
  null
  
)

export default component.exports